import React from 'react';
import { noop } from 'lodash';

import extractArrayData from '../../utils/extractArrayData';
import BladeContainer from '../UI/BladeContainer/BladeContainer';
import { Contentful } from '../../types';

import {
  BladeContent,
  Title,
  SubTitle,
  Time,
  Text,
  OptionButton,
} from './styles';

interface Props {
  bladeVisible: boolean;
  cms: any;
  inactive: number;
  remaining: number;
  continueSession: (params: any) => any;
  endSession: (params: any) => any;
}

const SessionTimeoutBlade = ({
  bladeVisible,
  cms,
  inactive,
  remaining,
  continueSession,
  endSession,
}: Props) => {
  const bladeLabels = extractArrayData(
    cms,
    Contentful.ContentfulId,
    '13DbvrAaxjRpA266AWScr1',
  ).formFields;

  // Blade Labels
  const heading = extractArrayData(
    bladeLabels,
    Contentful.ContentfulId,
    '1NQuhMHhRR4LC4jukl2loV',
  );
  const subheading = extractArrayData(
    bladeLabels,
    Contentful.ContentfulId,
    '7KaMMbR8tGmiYEXiWggwaX',
  );
  const timerUnit = extractArrayData(
    bladeLabels,
    Contentful.ContentfulId,
    '5MuW5Tq2XGruGOyHwNPwLe',
  );
  const warningMessage = extractArrayData(
    bladeLabels,
    Contentful.ContentfulId,
    '51uH3jnNeLEi2t9Qyo8S9e',
  );
  const actionMessage = extractArrayData(
    bladeLabels,
    Contentful.ContentfulId,
    '49wU6YfozfeDh7Zy7IMlkc',
  );

  const continueCta = extractArrayData(
    cms,
    Contentful.ContentfulId,
    '55pSlPreZK4pO7qxPlP9F3',
  );

  const endCta = extractArrayData(
    cms,
    Contentful.ContentfulId,
    '2veNhbW7h8dxxFasRCNnYd',
  );

  return (
    <BladeContainer
      bladeState={bladeVisible}
      setBladeState={noop}
      bladeWidth={767}
      showClose={false}
    >
      <BladeContent>
        <Title>{heading.displayLabel}</Title>
        <SubTitle>{subheading.displayLabel}</SubTitle>
        <Time data-testid="session-timeout-blade">
          {remaining}
          {' '}
          {timerUnit.displayLabel}
        </Time>
        <Text>
          {warningMessage.displayLabel.replace(
            '%inactiveTime%',
            (inactive / 60000).toFixed(0),
          )}
        </Text>
        <Text>
          {actionMessage.displayLabel}
          {' '}
        </Text>
        <OptionButton
          data-testid="session-timer-continue-button"
          aria-label={continueCta.ctaAriaLabel}
          buttonText={continueCta.ctaLabel.ctaLabel}
          buttonSize="large"
          route=""
          className={continueCta.ctaColor}
          onClick={continueSession}
        />
        <OptionButton
          data-testid="session-timer-end-button"
          aria-label={endCta.ctaAriaLabel}
          buttonText={endCta.ctaLabel.ctaLabel}
          buttonSize="large"
          route=""
          className={endCta.ctaColor}
          onClick={endSession}
        />
      </BladeContent>
    </BladeContainer>
  );
};

export default SessionTimeoutBlade;
